import { useEffect, useState } from "react";
import { api } from "@/lib/api-client";

export interface AccuracyRecentEvent {
  timestamp: string;
  documentId: string;
  wrongFormId: string;
  correctFormId: string;
}

export interface JobTypeAccuracyData {
  total: number;
  corrected: number;
  recent: AccuracyRecentEvent[];
  /** S-3 — omitted (not `undefined`-but-present) when OCR data is unavailable. */
  averageConfidence?: number;
  /** S-3 — omitted when there are no corrections to group. */
  topConfused?: Array<{ wrongFormId: string; correctFormId: string; count: number }>;
  /** S-3 — omitted alongside averageConfidence when OCR data is unavailable. */
  confidenceBuckets?: Array<{ min: number; max: number; count: number }>;
}

const EMPTY: JobTypeAccuracyData = { total: 0, corrected: 0, recent: [] };

export function useJobTypeAccuracy(jobTypeId: string) {
  const [data, setData] = useState<JobTypeAccuracyData>(EMPTY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    api
      .get<JobTypeAccuracyData>(`/job-types/${encodeURIComponent(jobTypeId)}/accuracy`)
      .then((json) => {
        if (!cancelled) setData(json);
      })
      .catch((err) => {
        if (!cancelled) {
          setData(EMPTY);
          setError(err instanceof Error ? err.message : "Failed to load");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [jobTypeId]);

  return { data, loading, error };
}
